// Metadati cantieri — i valori reali sono salvati su Supabase (app_settings → cantieriMeta)
// Questo oggetto è solo il default vuoto per nuovi cantieri non ancora configurati
export const CANTIERI_META_DEFAULT = {};
